import {InjectionToken} from '@angular/core';
import {BackgroundJobGlobalStatusUpdate} from '@domain/background-jobs/background-job-global-status-update';
import {Observable} from 'rxjs';

export const REALTIME_BACKGROUND_JOBS = new InjectionToken<RealtimeBackgroundJobs>('RealtimeBackgroundJobs');

export interface RealtimeBackgroundJobs {
  getJobGlobalStatusChanged(): Observable<BackgroundJobGlobalStatusUpdate>;
}
